<template>
  <div class="enrolling-admission-line-admit-cell">
    <el-popover
      popper-class="enrolling-admission-line-admit-popover"
      @keydown.enter.native="updateValue"
      @show="queryEditStatus"
      placement="top"
      width="300"
      v-model="visible">
      <div v-loading="loading">
        <template v-if="editStatus">
          <el-form ref="form" label-width="90px">
            <el-form-item label="录取结果：">
              <el-select v-model="admissionResult">
                <el-option label="录取" value="1"></el-option>
                <el-option label="不予录取" value="0"></el-option>
                <el-option label="放弃录取" value="2"></el-option>
                <el-option label="撤销录取" value="3"></el-option>
                <el-option label="保留录取" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="更改备注：">
              <el-input v-model="remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: center;">
            <el-button size="mini" @click="visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="updateValue" :loading="loading">确定</el-button>
          </div>
        </template>
      </div>
      <span slot="reference" class="data" :class="rowData['admissionCode'] === '1' ? 'grid-cell-success' : rowData['admissionCode'] === '0' ? 'grid-cell-danger' : rowData['admissionCode'] ? 'grid-cell-warning' : 'grid-cell-empty'">
        {{$attrs['cell-value'] ? $attrs['cell-value'] : '未设置'}}
        <span class="icon"><i class="el-icon-edit"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
import globalEvent from '../../../../../../../constants/globalEvent'
import routeConfig from '../../../../../../../constants/routeConfig'

export default {
  name: 'EnrollingAdmissionLineAdmitCell',
  props: {
    rowData: Object
  },
  data () {
    return {
      visible: false,
      loading: false,
      admissionResult: null,
      remark: '',
      editStatus: true
    }
  },
  created () {
    this.admissionResult = this.rowData['admissionCode']
  },
  activated () {
    this.admissionResult = this.rowData['admissionCode']
  },
  methods: {
    queryEditStatus () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/queryEditStatus',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.editStatus = response.data['editStatus']
              if (!this.editStatus) {
                this.visible = false
                this.$message.error('已过录取上报时间，不可修改')
              }
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateValue () {
      if (!this.admissionResult) {
        this.$message.warning('请选择录取结果')
        return false
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/updateAdmissionResult',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id,
          admissionResult: this.admissionResult,
          remark: this.remark
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('修改成功')
              this.visible = false
              this.$bus.$emit(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`)
              this.$emit('reloadGridData')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../../../styles/color';
.enrolling-admission-line-admit-cell {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  .data{
    cursor: pointer;
    .icon{
      color: $set-primary-color;
      margin-left: 5px;
    }
  }
}
</style>
